import React, { useEffect } from "react";
import tete from "../../assets/images/tete.png";
import "../../styles/SplashScreen.css";

const SplashScreen = ({ onFinish }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinish();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div style={styles.container}>
      <img src={tete} alt="tete" height={130} width={100} style={styles.image} />
      <pre style={styles.text}>
        {`
Winmauve XP Akalex Music Edition
Copyright (C) 2001-2025, Akalex Music, Inc.
Initializing Plug and Play Cards...
`}
      </pre>
      <p style={styles.footer}>LOADING</p>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: "black",
    color: "#5841ff",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "monospace",
  },
  text: {
    fontSize: "16px",
    whiteSpace: "pre-wrap",
    textAlign: "center",
    padding: "10px",
  },
  footer: {
    marginTop: "20px",
    fontSize: "14px",
    color: "#5841ff",
  },
  image: {
    animation: "blink 1s steps(1, start) infinite",
  },
};

export default SplashScreen;